import _taggedTemplateLiteral from "/home/runner/work/spa/spa/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2;
import styled from 'styled-components';
import { mediaMin } from '@spa/shared/theme';
export var Container = /*#__PURE__*/styled.section.withConfig({
  componentId: "sc-kolv0l-0"
})(["display:flex;flex-wrap:wrap;margin-top:", ";"], function (props) {
  return props.theme.space(5);
});
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-kolv0l-1"
})(["display:flex;flex-direction:column;font-family:'IntervalNextMed';color:", ";min-height:min-content;"], function (props) {
  return props.theme.typography.greyPrimary;
});
export var Title = /*#__PURE__*/styled.h1.withConfig({
  componentId: "sc-kolv0l-2"
})(["font-family:'IntervalNextReg';font-size:", ";line-height:", ";font-weight:600;border-bottom:0.5px solid ", ";&:not(:first-child){margin-top:", ";}"], function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.rem(48);
}, function (props) {
  return props.theme.colors.shadyGray;
}, function (props) {
  return props.theme.space(0);
});
export var Subtitle = /*#__PURE__*/styled.h2.withConfig({
  componentId: "sc-kolv0l-3"
})(["font-size:", ";line-height:", ";font-weight:600;margin:", " 0;&:last-child{margin-bottom:", ";}&:not(:first-child){margin-top:", ";}"], function (props) {
  return props.theme.rem(22);
}, function (props) {
  return props.theme.rem(30);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(5);
}, function (props) {
  return props.theme.space(5);
});
export var Item = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-kolv0l-4"
})(["flex:1 0 25%;margin:0 ", " ", " 0;height:50px;display:flex;max-width:30%;align-items:center;", " ", " svg{line-height:0;}svg:not(.unavailable-feature-icon){width:30px;height:30px;}span{font-family:'IntervalNextReg';font-size:", ";line-height:", ";margin-left:", ";}&.not_available{span{color:", ";}}"], function (props) {
  return props.theme.space(2.5);
}, function (props) {
  return props.theme.space(2);
}, mediaMin.mediumBreakpoint(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    flex: 1 0 40%;\n    max-width: unset;\n  "]))), mediaMin.extraSmallBreakpoint(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    flex: 1 0 50%;\n    max-width: unset;\n  "]))), function (props) {
  return props.theme.rem(16);
}, function (props) {
  return props.theme.rem(26);
}, function (props) {
  return props.theme.space(3);
}, function (props) {
  return props.theme.colors.shadyGray;
});